package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.image.ImageTarget
import fr.manyverse.app.domain.repository.CharacterRepository
import fr.manyverse.app.domain.repository.ImageStorageRepository
import fr.manyverse.app.domain.validation.CharacterValidator

class DeleteCharacterUseCase(
    private val characterRepository: CharacterRepository,
    private val imageStorageRepository: ImageStorageRepository
) {

    suspend operator fun invoke(
        characterId: String
    ): Result<Unit> {
        CharacterValidator.validateId(characterId).onFailure { return Result.failure(it) }

        // Get the character first to retrieve userId for image deletion
        val character = characterRepository.getCharacterById(characterId).getOrNull()

        // Delete the character image if it exists. Best effort: a failure is logged by the
        // repository and must not prevent the character deletion
        if (character?.imageUrl != null) {
            imageStorageRepository.delete(ImageTarget.CharacterAvatar(character.userId, characterId))
        }

        return characterRepository.deleteCharacter(characterId)
    }
}
